import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const uppercaseValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return /[A-Z]/.test(value) ? null : { missingUppercase: true };
};

export const numberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return /\d/.test(value) ? null : { missingNumber: true };
};

export const specialCharValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;

  const special = /[!@#$%^&*(),.?":{}|<>_\-\\/[\];'`~+=]/;

  return special.test(value) ? null : { missingSpecial: true };
};

/**
 * Cross–field validator for password match
 */
export const passwordsMatchValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const password = group.get('password')?.value as string;
  const confirm = group.get('passwordConfirm')?.value as string;

  return password === confirm ? null : { passwordsMismatch: true };
};
